import {
  TcClickTypes,
  TcPageTemplateNames,
} from 'src/configuration/tagcommander'
import { RegimeValues } from 'src/types'

import { FORM_ELEMENTS } from '../../components/FormElements/types'
import { RecipesFiltersProps } from '../../components/RecipesFilters'
import tcClick from '../tcClick/tcClick'

const currentItemMustBeFiltered = (
  arr: any[],
  idx: number,
  ignoredFilters: string[]
) => {
  if (arr[idx].name) {
    return ignoredFilters.findIndex((ignore) => ignore === arr[idx].name) !== -1
  }
  if (!arr[idx + 1]) {
    return false
  }

  return (
    ignoredFilters.findIndex((ignore) => ignore === arr[idx + 1].name) !== -1
  )
}

export const recipesFiltersTransformer = ({
  t,
  filters,
  handleFilterChange,
  handleApplyFilter,
  handleCloseFilter,
  ignoredFilters = [],
  recipeMainComponent,
  selectedSide,
  tcVars,
}: {
  t: any
  filters: { [key: string]: any }
  handleFilterChange: (field: any, values: any) => void
  handleApplyFilter: () => void
  handleCloseFilter: () => void
  ignoredFilters: string[]
  recipeMainComponent?: {
    label: string
    id: string
  }
  tcVars?: {
    chapter2: string
    chapter3: string
  }
  selectedSide?: string
}): RecipesFiltersProps => {
  return {
    filterButtonText: t('recipes_filters_filter_cta'),
    applyButtonText: t('recipes_filters_apply_cta'),
    formElements: recipeMainComponent
      ? [
          {
            type: 'SECTION_TITLE' as FORM_ELEMENTS.SECTION_TITLE,
            title: t('equivalent_recipes'),
          },
          {
            legend: recipeMainComponent.label,
            name:
              selectedSide === 'course'
                ? 'recipeMainComponent'
                : 'recipeMainComponentSide',
            type: 'CHECKBOX_GROUP' as FORM_ELEMENTS.CHECKBOX_GROUP,
            value:
              selectedSide === 'course'
                ? filters?.recipeMainComponent
                : filters?.recipeMainComponentSide,
            onChange: handleFilterChange,
            items: [
              {
                ...recipeMainComponent,
              },
              {
                label: t('component_other'),
                id: '0',
              },
            ],
          },
        ]
      : [
          {
            type: 'SECTION_TITLE' as FORM_ELEMENTS.SECTION_TITLE,
            title: t('filters_course_type'),
          },
          {
            legend: t('filters_course_type'),
            name: 'courseType',
            value: filters?.courseType,
            onChange: handleFilterChange,
            type: 'CHECKBOX_GROUP' as FORM_ELEMENTS.CHECKBOX_GROUP,
            items: [
              {
                id: 'START',
                label: 'Entrées',
              },
              {
                id: 'COURSE',
                label: 'Plats',
              },
              {
                id: 'SIDE',
                label: 'Accompagnements',
              },
              {
                id: 'DESSERT',
                label: 'Desserts',
              },
            ],
          },
          {
            type: 'SECTION_TITLE' as FORM_ELEMENTS.SECTION_TITLE,
            title: t('filters_diet'),
          },
          {
            type: 'SLIDER' as FORM_ELEMENTS.SLIDER,
            name: 'diet',
            value: filters?.diet,
            onChange: handleFilterChange,
            items: [
              {
                id: RegimeValues.NONE,
                label: 'Aucun',
              },
              {
                id: RegimeValues.NO_PORK,
                label: 'Sans porc',
              },
              {
                id: RegimeValues.NO_MEAT,
                label: 'Sans viande',
              },
              {
                id: RegimeValues.NO_FISH,
                label: 'Ni poisson',
              },
              {
                id: RegimeValues.NO_EGG,
                label: 'Ni oeuf',
              },
            ],
          },
          {
            type: 'SECTION_TITLE' as FORM_ELEMENTS.SECTION_TITLE,
            title: t('filters_cooking_time'),
          },
          {
            legend: t('filters_cooking_time'),
            name: 'cookingTime',
            type: 'CHECKBOX_GROUP' as FORM_ELEMENTS.CHECKBOX_GROUP,
            value: filters?.cookingTime,
            onChange: handleFilterChange,
            items: [
              {
                id: 'express',
                label: 'Express',
              },
            ],
          },
        ].reduce((acc: any, curr, idx, arr) => {
          if (!currentItemMustBeFiltered(arr, idx, ignoredFilters)) {
            return [...acc, curr]
          }

          return acc
        }, []),
    activeFiltersCount:
      Object.keys(filters)?.filter((k) => {
        return (
          k !== 'query' &&
          filters[k] !== RegimeValues.NONE &&
          filters[k]?.length !== 0 &&
          k !== 'recipeMainComponentSide'
        )
      })?.length ?? 0,
    applyButtonFunction: handleApplyFilter,
    closeButtonFunction: handleCloseFilter,
    onOpenFiltersClick: () => {
      tcClick({
        click_name: `amorcer_${t('recipes_filters_filter_cta')}_${
          TcPageTemplateNames.Recipes
        }_fam`,
        click_type: TcClickTypes.action,
        chapter1: `action_${TcPageTemplateNames.Recipes}_fam`,
        chapter2: tcVars?.chapter2 ?? '',
        chapter3: tcVars?.chapter3 ?? '',
      })
    },
  }
}
